import React from 'react';

const LoadingSpinner = ({ 
  message = "Loading...", 
  size = "large", 
  className = "" 
}) => {
  const sizeClasses = {
    small: "h-6 w-6",
    medium: "h-8 w-8", 
    large: "h-12 w-12",
    xlarge: "h-16 w-16"
  };

  const textSizeClasses = {
    small: "text-xs",
    medium: "text-sm",
    large: "text-sm md:text-base",
    xlarge: "text-base md:text-lg"
  };

  return (
    <div className={`min-h-screen flex flex-col ${className}`}>
      <div className="flex-grow flex flex-col items-center justify-center space-y-4">
        <div className={`animate-spin rounded-full ${sizeClasses[size]} border-t-2 border-b-2 border-orange-500`}></div>
        <p className={`text-gray-600 font-medium ${textSizeClasses[size]}`}>{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
